import { isString } from 'lodash';

const EMPTY_ANNOTATION_VALUE = 'None';
const ANNOTATION_ENTRIES_DELIMITER = ', ';
export const formatAnnotationValue = (entries) => {
  if (!Array.isArray(entries) || entries.length === 0) {
    return EMPTY_ANNOTATION_VALUE;
  }

  return entries
    .map((value) => (isString(value) ? value : value?.name))
    .join(ANNOTATION_ENTRIES_DELIMITER);
};
